import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Select from "./Select";
import TextArea from "./TextArea";
import Input from "./Input";
import moment from "moment";
import { searchUsers } from "../services/graphService";
import { msalInstance } from "./../../index";
import config from "../../config.json";

function SharedComment({ showModal, onHide, fields, onSave, commentToEdit }) {
  const [selectedField, setSelectedField] = useState("EntireForm");
  const [comment, setComment] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [userOptions, setUserOptions] = useState([]);

  useEffect(() => {
    document.addEventListener("focus", handleFocusChange, true);

    return () => {
      document.removeEventListener("focus", handleFocusChange, true);
    };
  }, []);

  useEffect(() => {
    if (commentToEdit) {
      setSelectedField(commentToEdit.field._text);
      setComment(commentToEdit.comment._text);
    }
  }, [commentToEdit]);

  const handleFocusChange = () => {
    if (document.activeElement.name)
      setSelectedField(document.activeElement.name);
  };

  const handleFieldOnChange = ({ currentTarget: input }) => {
    setSelectedField(input.value);
  };

  const handleCommentOnChange = ({ currentTarget: input }) => {
    setComment(input.value);
  };

  const handleSaveComment = () => {
    if (commentToEdit) {
      const commentXml = `<comment><createdby>${commentToEdit.createdby._text}</createdby><datetime>${commentToEdit.datetime._text}</datetime><field>${commentToEdit.field._text}</field><comment>${comment}</comment></comment>`;
      onSave(commentXml, commentToEdit);
    } else {
      const commentXml = `<comment><createdby>${
        JSON.parse(localStorage.getItem("safyInfo")).user.displayName
      }</createdby><datetime>${moment().format(
        "LLL"
      )}</datetime><field>${selectedField}</field><comment>${comment.replace(
        "&",
        "and"
      )}</comment></comment>`;
      onSave(commentXml, null, selectedUsers, comment);
    }

    setSelectedField("");
    setComment("");
  };

  const handleSearchUsers = async () => {
    const accessToken = await msalInstance.acquireTokenSilent({
      scopes: config.scopes,
    });
    searchUsers(accessToken, searchQuery).then((response) => {
      console.log(response);
      if (response) {
        const options = response.value.map((user) => ({
          _id: user.id,
          name: user.displayName,
          email: user.mail,
        }));
        setUserOptions(options);
      }
    });
  };

  const handleAddUser = ({ currentTarget: input }) => {
    if (input.value !== "") {
      const user = [...selectedUsers].filter(
        (obj) => obj._id === input.value
      )[0];

      if (!user) {
        let users = [...selectedUsers];
        users.push(
          [...userOptions].filter((option) => option._id === input.value)[0]
        );

        setSelectedUsers(users);
      }

      const options = [...userOptions].filter(
        (option) => option._id !== input.value
      );
      setUserOptions(options);
    }
  };

  const handleRemoveUser = (userId) => {
    const removedUser = [...selectedUsers].filter(
      (user) => user._id === userId
    );
    const options = [...userOptions];
    options.push(removedUser);
    setUserOptions(options);

    const obj = [...selectedUsers].filter((user) => user._id !== userId);
    setSelectedUsers(obj);
  };

  const handleHideModal = (e) => {
    onHide(e);
    setSelectedField("");
    setComment("");
  };

  return (
    <>
      {showModal ? (
        <Modal show={showModal} animation={false}>
          <Modal.Header>
            <Modal.Title>
              {commentToEdit ? "Edit Comment" : "Add Comment"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Select
              className="m-2"
              label="Comment for"
              value={selectedField}
              options={fields}
              onChange={handleFieldOnChange}
            />
            <TextArea
              label="Comment"
              value={comment}
              onChange={handleCommentOnChange}
            />
            <div className="row">
              <div className="col">
                <Input
                  label="Search for User(s)"
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.currentTarget.value);
                  }}
                />
              </div>
              <div className="col-3">
                <button
                  style={{ marginTop: "32px" }}
                  className="btn btn-primary"
                  onClick={handleSearchUsers}
                >
                  Search
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <Select
                  label="Select User(s)"
                  options={userOptions}
                  onChange={handleAddUser}
                />
              </div>
            </div>
            {selectedUsers.length > 0 && (
              <div className="row border-bottom">
                <div className="col border-end">Name</div>
                <div className="col">Email</div>
              </div>
            )}
            {selectedUsers.map((user) => (
              <div key={user._id} className="row border-bottom">
                <div className="col border-end">
                  <i
                    className="fas fa-times text-danger me-2 fa-lg"
                    onClick={() => {
                      handleRemoveUser(user._id);
                    }}
                  ></i>
                  {user.name}
                </div>
                <div className="col">{user.email}</div>
              </div>
            ))}
            <div>
              <button
                className="btn btn-primary m-2"
                onClick={(event) => {
                  event.preventDefault();
                  handleSaveComment();
                }}
              >
                Save
              </button>
              <button
                className="btn btn-secondary m-2"
                onClick={handleHideModal}
              >
                Cancel
              </button>
            </div>
          </Modal.Body>
        </Modal>
      ) : null}
    </>
  );
}

export default SharedComment;
